import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, retry, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { constants } from '../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  constructor(private http: HttpClient) { }



  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      // 'access-token': environment.prospektr_sell_backend_access_token
    }),
  };

  getResetLink(input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.prospector_resetLink;
    input.applicationID = 'PROSPECTOR',
      input.sendMail = false

    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  verifyResetLink(input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.prospector_verifyResetLink;
    input.applicationID = 'PROSPECTOR'
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }
  updatePassword(input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.prospector_updatePassword;
    input.applicationID = 'PROSPECTOR'
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  sentMessage(input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.prospector_sendMessage;
    // input.messageId = "HOMERISER_PASSWORD_RESET",
    //   input.subject = "Password Reset",
    //   input.from = "passwordreset@homerise.com",
    //   input.fromName = "Password Reset"
    return this.http
      .post<any>(url, input, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  errorHandl(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }

}
